import { ReducerState } from '../../store.types';

export const alpacaTransferSelector = ({ alpacaTransfer }: ReducerState) => alpacaTransfer;
